import script from "./AppExpandedTableBody.vue?vue&type=script&lang=ts"
export * from "./AppExpandedTableBody.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__